module.exports = "<div class=\"searchbox\">\n    <input type=\"text\" spellcheck=\"false\" placeholder=\"Ex. ski, sea, wine\" ng-keyup=\"$event.key == 'Enter' && $ctrl.searchPosts()\" ng-model=\"$ctrl.searchWord\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/sidebar/searchbox/searchbox.html
// module id = 562
// module chunks = 0